import { QrCodeIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import Image from "next/image";

export function WelcomeSection() {
  const t = useTranslations("components.sign_in");
  const ta = useTranslations("components.alt_text");

  return (
    <div className="relative hidden min-h-160 flex-col items-center justify-center gap-2 rounded-2xl bg-[#FFF8F2] px-8 pt-40 md:flex">
      <Image
        src="/dashboard-assets/home/sign-up/ornament.svg"
        alt={ta("decorative_ornament")}
        width={100}
        height={100}
        className="absolute end-0 top-0 w-full max-w-100 rtl:start-0 rtl:end-auto"
      />
      <QrCodeIcon
        width={40}
        height={40}
        className="text-h-500 absolute end-8 bottom-8"
      />
      <h1 className="text-ht-brown z-10 text-center text-3xl font-bold">
        {t("welcome_header")}
      </h1>
      <p className="z-10 text-center">{t("welcome_description")}</p>
    </div>
  );
}
